import { getCredentials } from "./authHelper";
import axios from "axios";

const AGRELLO_TOKEN_URL = "https://service.agrello.org/auth/oauth/token";

async function getAccessToken() {
  const credentials = await getCredentials();
  if (!credentials) {
    throw new Error("No credentials found. Please set up your Agrello API credentials in the settings.");
  }

  const { clientId, clientSecret } = credentials;

  try {
    console.log("Attempting to fetch access token...");
    const response = await axios.post(AGRELLO_TOKEN_URL, "grant_type=client_credentials", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Basic " + btoa(clientId + ":" + clientSecret),
      },
    });

    console.log("Response status:", response.status);

    var data = response.data;
    if (typeof data === "string") {
      data = JSON.parse(data);
    }

    var token = data.access_token || data.accessToken || data.token;
    if (!token) {
      throw new Error("No access token in response. Keys: " + Object.keys(data).join(", "));
    }
    return token;
  } catch (error) {
    console.error("Error in getAccessToken:", error.response ? error.response.data : error.message);
    throw new Error(`Failed to obtain access token: ${error.message}`);
  }
}

let cachedToken: string | null = null;
let tokenExpirationTime: number | null = null;

export async function getValidAccessToken(): Promise<string> {
  if (cachedToken && tokenExpirationTime && Date.now() < tokenExpirationTime) {
    return cachedToken;
  }

  const newToken = await getAccessToken();
  cachedToken = newToken;
  // Set expiration time to 5 minutes before the actual expiration (assuming 1 hour validity)
  tokenExpirationTime = Date.now() + 55 * 60 * 1000;
  return newToken;
}

export async function login(): Promise<string> {
  console.log("Login function called");
  try {
    const token = await getValidAccessToken();
    console.log("Successfully logged in");
    return token;
  } catch (error) {
    console.error("Login failed:", error);
    throw new Error(`Login failed: ${error.message || JSON.stringify(error)}`);
  }
}

export function logout(): void {
  cachedToken = null;
  tokenExpirationTime = null;
  console.log("Logged out");
}
